/**
 * -1, 0 or 1 for "0.1.7" style versions. An Android build number ("0.1.0+12", the APK's own
 * version name) counts after them, so a newer build of the same version is newer.
 */
export function compareVersions(a: string, b: string): number {
  const parts = (v: string) => {
    const [main = '', build = ''] = v.split('+');
    const p = main.split('.').map((n) => Number.parseInt(n, 10) || 0);
    while (p.length < 3) p.push(0);
    p.push(Number.parseInt(build, 10) || 0);
    return p;
  };
  const pa = parts(a);
  const pb = parts(b);
  for (let i = 0; i < Math.max(pa.length, pb.length); i++) {
    const d = (pa[i] ?? 0) - (pb[i] ?? 0);
    if (d) return d < 0 ? -1 : 1;
  }
  return 0;
}
